import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleButtonGroupComponent } from '@fc-shared/ui/toggle-button/toggle-button-group.component';
import { ToggleButtonComponent } from '@fc-shared/ui/toggle-button/toggle-button.component';

@NgModule({
  declarations: [ToggleButtonGroupComponent, ToggleButtonComponent],
  imports: [CommonModule],
  exports: [ToggleButtonGroupComponent, ToggleButtonComponent],
})
export class ToggleButtonModule {}
